import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
  Container,
} from "@mui/material";
import { styled } from "@mui/system";
import { db } from "../../../firestore-DB-config/firebase-config"; // Adjust this path to your Firebase config
import { collection, getDocs } from "firebase/firestore";
import Background from "../../../assets/images/Background.png";
import { Link } from "react-router-dom";

// Styled Components
const TeamWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  textAlign: "left",
  position: "relative",
}));

const TeamCard = styled(Card)(({ theme }) => ({
  maxWidth: "240px",
  borderRadius: "20px",
  background: "linear-gradient(219.84deg, #474747 4.14%, #222222 44.22%)", // Gradient background
  color: "#fff",
  position: "absolute",
  top: "50%",
  right: "-23%",
  transform: "translateY(-50%)",
  boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "70%",
    marginLeft: "auto",
    marginRight: "auto",
    left: 0,
    right: 0,
  },
}));

const AvatarImage = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
  marginBottom: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#012c5f",
  color: "#FFFFFF",
  borderRadius: "30px",
  padding: "10px 30px",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#013A72",
  },
}));

// TeamSection Component
const TeamSection: React.FC = () => {
  const [teamMember, setTeamMember] = useState<any>(null);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      const teamCollectionRef = collection(db, "teamMembers");
      const querySnapshot = await getDocs(teamCollectionRef);

      if (!querySnapshot.empty) {
        // Get the first document in the collection
        const firstMember = querySnapshot.docs[0].data();
        setTeamMember(firstMember);
      }
    };

    fetchTeamMembers();
  }, []);

  if (!teamMember) {
    return <Typography>Loading...</Typography>; // Show loading state
  }

  return (
    <Container sx={{ my: { xs: 6, md: 9 }, px: { xs: 4, md: 4, lg: 0 } }}>
      <TeamWrapper>
        <Typography
          variant="h5"
          fontWeight={700}
          color="rgba(1, 29, 51, 1)"
          gutterBottom
          sx={{ fontSize: { xs: "24px", sm: "28px" } }} // Responsive heading
        >
          OUR TEAM MEMBERS
        </Typography>
        <Typography
          variant="h4"
          fontWeight={540}
          mb={2}
          color="rgba(1, 29, 51, 1)"
          sx={{ fontSize: { xs: "22px", sm: "32px" } }} // Responsive subheading
        >
          {"Lorem Ipsum Lorem Ipsum"}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#7A7A7A",
            marginBottom: "20px",
            fontSize: { xs: "14px", sm: "16px" }, // Responsive body text
          }}
        >
          {
            "Donec Porttitor Euismod Dignissim. Nullam A Lacinia Ipsum, Nec Dignissim Purus. Nulla Convallis Ipsum Molestie Nibh Malesuada."
          }
        </Typography>

        {/* Flexbox layout for the Background Image and Card overlay, and the Text + Button section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Stack on small screens, row on larger
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 6, md: 18 }, // Adjust gap based on screen size
          }}
        >
          {/* Background Image with Card Overlay */}
          <Box
            sx={{
              position: "relative",
              backgroundImage: `url(${Background})`, // Dynamic background image from Firestore
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: { xs: "300px", sm: "400px" }, // Adjust height for different screen sizes
              width: { xs: "100%", md: "45%" }, // 50% width on larger screens, full width on small
              borderRadius: "2px", // Rounded corners
            }}
          >
            {/* Team Member Card */}
            <TeamCard>
              <CardContent>
                <AvatarImage alt={teamMember.name} src={teamMember.imageUrl} />
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {teamMember.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ marginTop: "10px", fontSize: "14px" }}
                >
                  {teamMember.description}
                </Typography>
              </CardContent>
            </TeamCard>
          </Box>

          {/* Text + Button Section */}
          <Box
            sx={{
              flex: 1,
              textAlign: { xs: "center", md: "left" }, // Center text on small screens, left on larger
              marginTop: { xs: "30px", md: "0" }, // Add space between sections on small screens
            }}
          >
            <Typography
              fontSize={{ xs: 22, sm: 28 }}
              sx={{ fontWeight: "bold", color: "#012c5f" }}
            >
              {"LOREM IPSUM DIP SUM DIP GIM GIL MER"}
            </Typography>
            <Typography
              fontSize={{ xs: 14, sm: 15 }}
              sx={{ color: "#7A7A7A", marginTop: "10px" }}
            >
              {
                "All our teams are professional and competent in their fields and will help you realize your dream building with the excellent result. More than 20 years of experience in the field architecture and has worked on project up to 100+"
              }
            </Typography>

            <Box
              sx={{
                marginTop: "30px",
                display: "flex",
                justifyContent: { xs: "center", md: "flex-start" }, // Center on small screens, left on large
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Link to="/allTeam" style={{ textDecoration: "none" }}>
                <StyledButton>See All Team</StyledButton>
              </Link>

              <Typography
                variant="body2"
                sx={{ color: "#013A72", cursor: "pointer", fontSize: 14 }}
              >
                <Link
                  to={"/allTeam"}
                  style={{ textDecoration: "none", color: "inherit" }} // Remove underline and inherit color
                  onClick={() => window.scrollTo(0, 0)}
                >
                  How it works →
                </Link>
              </Typography>
            </Box>
          </Box>
        </Box>
      </TeamWrapper>
    </Container>
  );
};

export default TeamSection;
